import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import { Store } from '../store'

import * as body from './body'
import * as footer from './footer'

/**
 * Modal used to edit org chart nodes
 */
@ngCore.Component({
  imports: [
    ds.overlay.centered.Component,
    ds.layout.widget.Component,
    body.Component,
    footer.Component,
  ],
  selector: 'atn-summit-org-chart-node-panel',
  standalone: true,
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link Store} */
  public readonly store = ngCore.inject(Store)
}
